const themeColor = {
  blueGreen: "#1fb2af",
  blueGrey: "#546A76",
  black: "#000000",
};

export default themeColor;
